var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 15.75V5.25H7.125V3.75L9.375 1.5L11.625 3.75V8.25H16.125V15.75H2.625ZM4.125 14.25H5.625V12.75H4.125V14.25ZM4.125 11.25H5.625V9.75H4.125V11.25ZM4.125 8.25H5.625V6.75H4.125V8.25ZM8.625 14.25H10.125V12.75H8.625V14.25ZM8.625 11.25H10.125V9.75H8.625V11.25ZM8.625 8.25H10.125V6.75H8.625V8.25ZM8.625 5.25H10.125V3.75H8.625V5.25ZM13.125 14.25H14.625V12.75H13.125V14.25ZM13.125 11.25H14.625V9.75H13.125V11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotels);
export default __webpack_public_path__ + "static/media/hotels.b47dcd18ab59b39e0c703b469541f73a.svg";
export { ForwardRef as ReactComponent };